var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 315,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7096",
    d: "M0 0h240v315H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCCDA",
    d: "M119.5-68C-25.475-68-143 49.75-143 195h525C382 49.75 264.475-68 119.5-68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCCDA",
    d: "M120 178c-85.052 0-154 68.948-154 154h308c0-85.052-68.948-154-154-154Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPink);
export default __webpack_public_path__ + "static/media/backgroundPink.b3f1caeacc871d8eb6ce1bea7bc36152.svg";
export { ForwardRef as ReactComponent };